import { CNC } from '@clickncode/frontend/client'
import Deferred from 'p-defer'
// Doing this so we don't try to import the server-side code
import { client as webauthnClient, utils as webauthnUtils } from '@passwordless-id/webauthn'

window.CNC = CNC
window.addEventListener('DOMContentLoaded', () => CNC.start(), { once: true })

window.Deferred = Deferred

window.webauthn = {
  client: webauthnClient,
  utils: webauthnUtils
}
